import { render, staticRenderFns } from "./winSizeChange.vue?vue&type=template&id=6dae738e&scoped=true"
import script from "./winSizeChange.vue?vue&type=script&lang=js"
export * from "./winSizeChange.vue?vue&type=script&lang=js"
import style0 from "./winSizeChange.vue?vue&type=style&index=0&id=6dae738e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dae738e",
  null
  
)

export default component.exports